import { FilterModel } from "../filter.model";

export class DtRowModel {

  locationUid: number;
  addressName: string;
  addressOne: string;
  addressTwo: string;
  addressCity: string;
  addressPostCode: string;
  organisationSelect: FilterModel;
  organisationUid: number;
  organisationName: string;
  allReportsDone: number;
  locationCode: string;
  lastJobDateTime: string;
  lastReportDateTime: string;
  lastQuoteDateTime: string;
  assetCount: number;

  createdDateTime: string;
  assetUid: number;
  assetName: string;
  locationName: string;
  assetTypeName: string;
  uid: number;
  name: string;
  description: string;
  assetGroupUid: number;
  assetGroupName: string;
  conditionNotes: string;
  hasImages: string;
  postCode: string;

  jobUid: number;
  jobDate: string;
  clientOrderNumber: string;
  jobStatusName: string;
  jobStatusUid: number;
  jobTypeUid: number;
  jobId: string;

  managerName: string;
  engineerName: string;
  engineerCompletedDate: string;

  userUid: number;
  userRole: string;
  userEmail: string;

  orderUid: number;
  orderStatus: string;
  requestedByUser: string;

  deviceModel: string;
  deviceEmail: string;
  deviceLastLogin: string;
  appVersion: string;
  appTypeUid: string;

  stockItemUid: number;
  stockItemName: string;
  stockItemCount: string;

  stockPresetUid: number;
  stockPresetName: string;

  vehicleVrm: string;
  vehicleUid: number;
  vehicleDescription: string;
  vehicleRating: string;
  vehicleMileage: string;

  constructor() {
  }
}